import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { institutionCopy } from '../../data/landingData';
import { fadeInUp, staggerContainer } from '../../utils/motion';
import { SectionTitle } from '../ui/SectionTitle';

// Asumimos que las imágenes se colocarán en src/assets/ o ajusta la ruta si es necesario.
// Si las imágenes están en la raíz del proyecto, Create React App requerirá que estén en src/.
import img1 from '../../assets/jo_inst (1).png';
import img1_2 from '../../assets/jo_inst 2.png';
import img2 from '../../assets/uni_inst.png';
import img3 from '../../assets/uni_inst2.png';

const carouselImages = [img1, img1_2, img2, img3];

function AutoCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % carouselImages.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="relative w-full max-w-[200px] sm:max-w-[220px] lg:max-w-[240px] mx-auto drop-shadow-xl flex justify-center overflow-hidden">
      {/* Placeholder invisible para mantener el tamaño y proporción exactos de la imagen */}
      <img src={carouselImages[0]} className="w-full object-contain invisible pointer-events-none" alt="" />
      
      <AnimatePresence mode="popLayout">
        <motion.img
          key={currentIndex}
          src={carouselImages[currentIndex]}
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -20 }}
          transition={{ duration: 0.5 }}
          className="absolute top-0 left-0 w-full h-full object-contain"
          alt={`Mockup Instituciones ${currentIndex + 1}`}
        />
      </AnimatePresence>
    </div>
  );
}

export function InstitutionsSection() {
  return (
    <section id="instituciones" className="bg-white py-8 sm:py-10">
      <div className="container-base">
        <motion.div
          className="overflow-hidden rounded-[2rem] bg-brand-500 px-6 py-12 sm:px-10"
          variants={staggerContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
        >
          <motion.div variants={fadeInUp}>
            <SectionTitle title={institutionCopy.title} subtitle={institutionCopy.description} centered onDark />
          </motion.div>

          <motion.div variants={fadeInUp} className="mt-10 flex justify-center">
            <AutoCarousel />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
